module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Communication/Adress-book-1-00d315e34f26f408b079854c954fa063.svg";